export const bool = () => arg => typeof arg === 'boolean';
export const cssProperties = () => arg => typeof arg === 'object';
export const string = () => arg => typeof arg === 'string';
export const literal = str => arg => arg === str;
export const number = () => arg => typeof arg === 'number';
export const keyboardEventKeys = () => arg => {
  try {
    return typeof arg === 'object' && typeof arg.altKey === 'boolean' && typeof arg.ctrlKey === 'boolean' && typeof arg.metaKey === 'boolean' && typeof arg.shiftKey === 'boolean' && typeof arg.key === 'string';
  } catch (ex) {
    return false;
  }
};
export const anyObject = () => arg => typeof arg === 'object';

// Please avoid nesting object validators
export const object = validatorMap => arg => anyObject()(arg) && Object.entries(validatorMap).every(([key, validator]) => key in arg && validator(arg[key]));
export const optional = validator => arg => arg === undefined || validator(arg);
export const arrayOf = validator => arg => Array.isArray(arg) && arg.every(validator);
export const or = (...validators) => arg => validators.some(v => v(arg));
export const and = (...validators) => arg => validators.every(v => v(arg));
export const empty = () => arg => typeof arg === 'undefined';
export const nullType = () => arg => arg === null;
export const oneOf = values => arg => values.includes(arg);